import { useEffect, useState } from 'react';

type Status = 'success' | 'error';

export const DiscordSuccess = () => {
    const [status, setStatus] = useState<Status | null>(null);
    const [message, setMessage] = useState('');
    const [username, setUsername] = useState<string | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const success = params.get('success');
        const error = params.get('error');
        const discordUsername = params.get('username');

        if (success === 'true') {
            setStatus('success');
            setUsername(discordUsername);
            setMessage('Successfully linked your Discord account!');
        } else if (error) {
            setStatus('error');
            const errorMessages: Record<string, string> = {
                'access_denied': 'You cancelled the Discord authorization.',
                'missing_params': 'Missing authorization parameters. Please try again.',
                'not_configured': 'Discord integration is not configured.',
                'invalid_state': 'Invalid session. Please try again.',
                'token_exchange_failed': 'Failed to connect with Discord. Please try again.',
                'user_fetch_failed': 'Failed to get your Discord info. Please try again.',
                'already_linked': 'This Discord account is already linked to another BetterCampus account.',
            };
            setMessage(errorMessages[error] || `An error occurred: ${error}`);
        }
    }, []);

    if (!status) {
        return (
            <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
                <div className="bg-white rounded-2xl p-12 shadow-2xl text-center max-w-lg">
                    <div className="w-8 h-8 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mx-auto" />
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
            <div className="bg-white rounded-2xl p-12 shadow-2xl text-center max-w-lg">
                {status === 'success' && (
                    <>
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-semibold mb-2 text-gray-900">{message}</h1>
                        {username && (
                            <p className="text-gray-600 mb-4">Connected as <span className="font-medium text-indigo-600">{username}</span></p>
                        )}
                        <p className="text-gray-500 text-sm mb-6">You've joined the BetterCampus Discord community!</p>
                        <button
                            onClick={() => window.close()}
                            className="px-6 py-2 bg-indigo-500 hover:bg-indigo-600 rounded-lg text-white font-medium transition-colors"
                        >
                            Close
                        </button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-semibold mb-2 text-gray-900">Link Failed</h1>
                        <p className="text-gray-600 mb-6">{message}</p>
                        <button
                            onClick={() => window.close()}
                            className="px-6 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 font-medium transition-colors"
                        >
                            Close
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default DiscordSuccess;
